function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
import React from 'react';
import { useFormContext } from 'react-hook-form';
import { Controls, validators } from 'shared/helper/form';
import { T, useTranslate } from 'shared/helper/translate';
import AddressForm from './AddressFormContainer';
var notEmpty = validators.notEmpty,
  chinesePhoneValid = validators.chinesePhoneValid,
  createRegularExpressionValidator = validators.createRegularExpressionValidator;
var eightDigitZipCodeValid = createRegularExpressionValidator(/^\d{5}-?\d{3}$/);
var Checkbox = Controls.Checkbox,
  Hidden = Controls.Hidden;
var BillingAndInvoiceAddress = function BillingAndInvoiceAddress(_ref) {
  var addressFieldDisplaySettings = _ref.addressFieldDisplaySettings,
    includePhoneNumberDescription = _ref.includePhoneNumberDescription,
    invoiceAddressAvailable = _ref.invoiceAddressAvailable,
    invoiceAddressFieldDisplaySettings = _ref.invoiceAddressFieldDisplaySettings,
    isChinaUser = _ref.isChinaUser,
    selectableCountries = _ref.selectableCountries,
    usingBrazilianPaymentMethod = _ref.usingBrazilianPaymentMethod;
  var _useTranslate = useTranslate(),
    t = _useTranslate.t;
  var methods = useFormContext();
  var _methods$watch = methods.watch(['billingAddress', 'invoiceAddress', 'invoiceAddressDiffersFromBilling', 'requireFapiao']),
    _methods$watch2 = _slicedToArray(_methods$watch, 4),
    billingAddress = _methods$watch2[0],
    invoiceAddress = _methods$watch2[1],
    invoiceAddressDiffersFromBilling = _methods$watch2[2],
    requireFapiao = _methods$watch2[3];
  var billingAddressName = billingAddress && billingAddress.name ? billingAddress.name : t('billing-address-name');
  return /*#__PURE__*/React.createElement("div", {
    className: "address-form-container"
  }, /*#__PURE__*/React.createElement(AddressForm, {
    address: billingAddress,
    name: addressFieldDisplaySettings.addressFormName,
    nameField: addressFieldDisplaySettings.displayNameField ? addressFieldDisplaySettings.nameField : false,
    organizationField: addressFieldDisplaySettings.displayOrganizationField,
    organizationFieldDescription: addressFieldDisplaySettings.organizationFieldDescription,
    organizationFieldLabel: addressFieldDisplaySettings.organizationFieldLabel,
    phoneField: addressFieldDisplaySettings.displayPhoneField,
    phoneValidation: {
      message: requireFapiao ? 'Phone number must be 11 digits.' : 'Phone number is required',
      validator: requireFapiao ? chinesePhoneValid : notEmpty,
      description: includePhoneNumberDescription ? 'Please use mobile phone numbers only.' : null,
      minLength: 7,
      maxLength: 25
    },
    required: !isChinaUser,
    selectableCountries: selectableCountries,
    philDefaultCountry: true,
    type: addressFieldDisplaySettings.type,
    vatField: addressFieldDisplaySettings.displayVatField,
    zipCodeField: {
      message: usingBrazilianPaymentMethod ? 'Postcode must be 8 digits.' : 'Please enter your zip code.',
      validator: usingBrazilianPaymentMethod ? eightDigitZipCodeValid : notEmpty
    },
    Controls: Controls,
    validators: validators
  }), invoiceAddressAvailable ? /*#__PURE__*/React.createElement("div", {
    className: "row"
  }, /*#__PURE__*/React.createElement("div", {
    className: "col-12"
  }, /*#__PURE__*/React.createElement(T.md, {
    source: "your-invoice-will-display-x-as-the-invoice-payer",
    params: billingAddressName
  }), /*#__PURE__*/React.createElement(Checkbox, {
    className: "form-check-input",
    label: "Send invoice to a different address",
    name: "invoiceAddressDiffersFromBilling"
  }))) : /*#__PURE__*/React.createElement(Hidden, {
    name: "invoiceAddressDiffersFromBilling",
    value: true
  }), invoiceAddressDiffersFromBilling && invoiceAddressAvailable ? /*#__PURE__*/React.createElement(AddressForm, {
    address: invoiceAddress,
    Controls: Controls,
    name: "invoiceAddress",
    organizationField: invoiceAddressFieldDisplaySettings.displayOrganizationField,
    organizationFieldDescription: invoiceAddressFieldDisplaySettings.organizationFieldDescription,
    organizationFieldLabel: invoiceAddressFieldDisplaySettings.organizationFieldLabel,
    selectableCountries: selectableCountries,
    philDefaultCountry: true,
    type: "invoice",
    vatField: true,
    validators: validators
  }) : null);
};
export default BillingAndInvoiceAddress;